export const TRIAL_PAYWALL_VARIANT_KEY = 'variant_trial_paywall';
